import { motion } from "framer-motion";
import { useLanguage } from "@/contexts/language-context";

export function DimensionsShowcase() {
  const { t } = useLanguage();

  const dimensions = [
    { label: t("dimensions.length"), value: "4800", unit: "mm" },
    { label: t("dimensions.width"), value: "1680", unit: "mm" },
    { label: t("dimensions.height"), value: "1930", unit: "mm" },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-1"
        >
          <div className="inline-block mb-4 px-6 py-2 bg-blue-100 rounded-full">
            <span className="text-blue-600 font-semibold">{t("dimensions.badge")}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            {t("dimensions.title")}
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            {t("dimensions.subtitle")}
          </p>
        </motion.div>

        <div className="max-w-7xl mx-auto">
          {/* 3-View Images - Horizontal Layout */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="flex flex-col gap-0 mb-2"
          >
            <img src="/img/车身尺寸透视图.png"
              alt="Vehicle Dimensions - Front & Side View" className="w-full h-auto"
            />
            <img src="/img/车身尺寸透视图-2.png"
              alt="Vehicle Dimensions - Top View" className="w-3/4 h-auto mx-auto"
            />
          </motion.div>

          {/* Dimension Cards */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3, duration: 0.6 }}
            className="grid grid-cols-3 gap-4 md:gap-6 max-w-3xl mx-auto"
          >
            {dimensions.map((dim, index) => (
              <motion.div
                key={dim.label}
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.4 + index * 0.1, duration: 0.5 }}
                className="bg-gradient-to-br from-slate-50 to-blue-50 rounded-2xl p-6 text-center border border-gray-100"
              >
                <p className="text-3xl md:text-4xl font-bold text-gray-900">
                  {dim.value}
                  <span className="text-base md:text-lg text-gray-500 ml-1 font-normal">{dim.unit}</span>
                </p>
                <p className="text-sm text-gray-600 mt-2">{dim.label}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}

